import { Intent } from "@blueprintjs/core";
import { ButtonWithDialog } from "@focus/focusUI";
import { useMemo } from "react";
import { usePhonebook } from "../../hooks/usePhonebook";
import { ROLES, useRoles } from "../../hooks/useRoles";
import type { Organization } from "../../types/phonebook";
import { useMe } from "../../hooks/useMe";

interface DeleteOrganizationButtonProps {
  organization: Organization;
}

export const DeleteOrganizationButton = ({
  organization,
}: DeleteOrganizationButtonProps) => {
  const me = useMe();
  const { deleteOrganization } = usePhonebook();
  const { roles } = useRoles();

  const canDelete = useMemo(() => {
    if (roles.includes(ROLES.ADMIN)) return true;
    if (!roles.includes(ROLES.ORG_ADMIN)) return false;

    return me?.organizations?.includes(organization.name);
  }, [roles, me?.organizations, organization.name]);

  if (!canDelete) return null; // Do not show button

  return (
    <ButtonWithDialog<null>
      icon="trash"
      minimal
      intent={Intent.DANGER}
      headerTitle="Confirm Delete"
      defaultContent={null}
      closeAfterAccept={true}
      onAccept={() => deleteOrganization(organization.id)}
      hideButtons={false}
      form={() => (
        <div className="w-full p-4 text-center space-y-3">
          <p>
            Are you sure you want to delete <b>{organization.name}</b>?
          </p>
          <p className="text-sm text-gray-500">This action cannot be undone.</p>
        </div>
      )}
    />
  );
};
